type ApiErrorPayload = {
  errors?: Record<string, unknown>;
  message?: string;
};

type ApiErrorLike = {
  code?: string;
  config?: {
    baseURL?: string;
    url?: string;
  };
  request?: unknown;
  response?: {
    data?: ApiErrorPayload;
  };
  message?: string;
};

const flattenMessages = (value: unknown): string[] => {
  if (Array.isArray(value)) {
    return value.flatMap((item) => flattenMessages(item));
  }

  if (typeof value === 'string') {
    return value.trim() ? [value.trim()] : [];
  }

  return [];
};

export const extractApiErrorMessage = (error: unknown, fallback: string): string => {
  const apiError = error as ApiErrorLike | null;

  if (apiError?.code === 'ERR_NETWORK' || (apiError?.request && !apiError?.response)) {
    const apiUrl = [apiError.config?.baseURL, apiError.config?.url]
      .filter(Boolean)
      .join('');

    return apiUrl
      ? `Impossible de joindre le serveur API (${apiUrl}). Vérifiez que l'API est démarrée et que cette adresse est accessible depuis ce navigateur.`
      : "Impossible de joindre le serveur API. Vérifiez que l'API est démarrée et accessible depuis ce navigateur.";
  }

  const data = apiError?.response?.data;
  const messages = data?.errors
    ? Object.values(data.errors).flatMap((value) => flattenMessages(value))
    : [];

  return messages.join(' ') || data?.message || apiError?.message || fallback;
};
